import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { useLanguage } from "../i18n/LanguageContext";

export const Faq = () => {
  const { t } = useLanguage();

  return (
    <section id="intrebari" className="bg-white py-20 lg:py-28" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <p className="section-label" data-testid="faq-label">{t.faq.label}</p>
        <h2
          className="font-display mt-4 text-3xl font-bold tracking-tight text-[#0d2b52] sm:text-4xl"
          data-testid="faq-title"
        >
          {t.faq.title}
        </h2>

        <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
          {t.faq.items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="border-[#e2e8f0]"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger
                className="font-display text-left text-base font-bold text-[#0d2b52] hover:text-[#1d6fd1] hover:no-underline sm:text-lg"
                data-testid={`faq-question-${i}`}
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent
                className="text-base leading-relaxed text-[#475569]"
                data-testid={`faq-answer-${i}`}
              >
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
